import { CHANNELS_HAS_ERRORED, CHANNELS_IS_LOADING, CHANNELS_DATA_SUCCESS } from './types';
import { globalFetch } from './globalActions';
import { FEED_URLSRC_CMS_V2 } from '../constants';
import { cmsImageBaseUrlV2 } from '../helpers';

///////////
// Channel Feed //
///////////

export function channelsFetchDataSuccess(items) {
	//Update to replace url image urls that contain cloudfront into s4c domain ones
	const updatedResults = items?.results?.length > 0 ? items.results.map(result => ({
		...result,
		iconImage: result?.iconImage?.path ? {
		  ...result.iconImage,
		  url: `${cmsImageBaseUrlV2()}/media/${result.iconImage.path}`
		} : result.iconImage,
		logoImage: result?.logoImage?.path ? {
		  ...result.logoImage,
		  url: `${cmsImageBaseUrlV2()}/media/${result.logoImage.path}`
		} : result.logoImage,
		backgroundImage: result?.backgroundImage?.path ? {
		  ...result.backgroundImage,
		  url: `${cmsImageBaseUrlV2()}/media/${result.backgroundImage.path}`
		} : result.backgroundImage
	  })) : [];

	return {
		type: CHANNELS_DATA_SUCCESS,
		payload: updatedResults
	};
}

export function channelsFetchData() {
	return globalFetch({
		urlPath: "channels",
		urlSrc: FEED_URLSRC_CMS_V2,
		reducerIsLoading: CHANNELS_IS_LOADING,
		reducerError: CHANNELS_HAS_ERRORED,
		dispatchSuccess: (itemObj, dispatch) => {
			dispatch(channelsFetchDataSuccess(itemObj));
		}
	});
}
